import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, RouterModule,  ActivatedRoute  } from '@angular/router';
import { AlertifyService } from '@services/alertify.service';
import { AuthService } from '@services/auth.service';
import { UserDto } from '@models/user-dto';
import { Country } from '@models/country';
import { State } from '@models/state';
import { UserClassesService } from '@services/user-classes.service';
import { CountryService } from '@services/country.service';
import { UserCourseDto, createUserCourseDto } from '@models/user-course-dto';
import { UserService } from '@services/user.service';
import { CustomValidators } from '@shared/validators/custom.validators';
import { UserOne } from '@models/userone';
import { UserClassesTaken } from '@models/user-classes-taken';
import { classItem } from '@models/classItem';
import { ClassService } from '@services/class.service';
// Child Components
import { AppUserInfoCardComponent } from './components/app-user-info-card/app-user-info-card.component';
import { AppAdminNavMenuComponent } from './components/app-admin-nav-menu/app-admin-nav-menu.component';
import { AppPanelHeaderComponent } from './components/app-panel-header/app-panel-header.component';
import { AppPersonalInfoFormComponent } from './components/app-personal-info-form/app-personal-info-form.component';
import { AppPasswordChangeFormComponent } from './components/app-password-change-form/app-password-change-form.component';
import { AppCourseProgressTableComponent } from './components/app-course-progress-table/app-course-progress-table.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { state } from '@angular/animations';
import { UserEnrolmentService } from '@services/user-enrolment.service';
// import { ConsoleReporter } from 'jasmine';
//import 'rxjs/operator/filter';

declare function getToday(): any;

@Component({
  selector: 'admin-panel-user',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    AppUserInfoCardComponent,
    AppAdminNavMenuComponent,
    AppPanelHeaderComponent,
    AppPersonalInfoFormComponent,
    AppPasswordChangeFormComponent,
    AppCourseProgressTableComponent
  ],
  templateUrl: './admin-panel-user.component.html',
  styleUrls: ['./admin-panel-user.component.css'] //'../../../assets/bootstrap/css/bootstrap.min.css'
})
export class AdminUserComponent implements OnInit {
  model: any = {};
  addToClassForm: FormGroup;
  processing: boolean;
  userCourseDto: UserCourseDto; // to check if the course is completed
  email: string;
  token: string;
  id: string;
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
  isRefreshing = false;
  // users: UserReports[];
  user: UserOne;
  userProfForm: FormGroup;
  userPassForm: FormGroup;
  countries: Country[];
  states: State[] = [];

  userClassesList: classItem[];  //list of all classes
  userClassesTakenList: UserClassesTaken[]; // list of classes completed by the student
  //userClassesList: [Class][UserClassesTaken];  
  // userClassesListds = new Map(); 
  fileName= 'ExcelSheet.xlsx';
  classCompleted: string = "no";
  // startedDate: Date;
  // completedDate: Date;
  // availableDate: Date;
  editMode: boolean = false;
  editPersonalMode: boolean = false;
  editPasswordMode: boolean = false;
  
  // Navigation state for the new panel layout
  activePanel: string = 'personal'; // 'personal', 'courses', 'activity'
  isAvailable: boolean[] = [false, false, true, true, false, true, false, true, false,true];
  userClassesListds = new Map();

  courseCompleted: number = 0; // To track the number of classes completed for progress display


  // Panel configuration
  personalInfoConfig = {
    title: 'Personal Information',
    icon: 'fa-user',
    editButtonText: 'Edit Information'
  };

  passwordConfig = {
    title: 'Change Password',
    icon: 'fa-lock',
    editButtonText: 'Change Password'
  };

  courseConfig = {
    title: 'Course Information & Progress',
    icon: 'fa-book',
    editButtonText: 'Edit Progress'
  };

  // Certificate generation state
  isGeneratingCertificate: boolean = false;

  // Admin-specific enrollment statistics
  adminStats: {
    enrollmentDate?: Date;
    isCertificateSent?: boolean;
    courseCompleted?: boolean;
    completionDate?: Date;
    completionPercentage?: number;
    activitiesCompleted?: number;
    totalActivities?: number;
  } = {};

  // Event handlers for child components
  onPanelChange(panel: string): void {
    this.activePanel = panel;
  }

  // Event handlers for edit mode changes from child components
  onPersonalEditModeChange(editMode: boolean): void {
    this.editPersonalMode = editMode;
    this.updatePersonalFormState();
  }

  onPasswordEditModeChange(editMode: boolean): void {
    this.editPasswordMode = editMode;
    this.updatePasswordFormState();
  }

  onCourseEditModeChange(editMode: boolean): void {
    this.editMode = editMode;
  }

  // Methods to handle form enable/disable states
  private updatePersonalFormState(): void {
    if (this.userProfForm) {
      if (this.editPersonalMode) {
        this.userProfForm.enable();
      } else {
        this.userProfForm.disable();
      }
    }
  }

  private updatePasswordFormState(): void {
    if (this.userPassForm) {
      if (this.editPasswordMode) {
        this.userPassForm.enable();
        // Keep email field disabled as it should be read-only
        this.userPassForm.get('email1')?.disable();
      } else {
        this.userPassForm.disable();
      }
    }
  }

  // Methods to toggle edit modes
  togglePersonalEditMode(): void {
    this.editPersonalMode = !this.editPersonalMode;
    this.updatePersonalFormState();
  }

  togglePasswordEditMode(): void {
    this.editPasswordMode = !this.editPasswordMode;
    this.updatePasswordFormState();
  }

  onPersonalInfoSave(): void {
    this.saveUser();
    this.editPersonalMode = false;
    this.updatePersonalFormState();
  }

  onPasswordSave(): void {
    this.savePass();
    this.editPasswordMode = false;
    this.updatePasswordFormState();
  }

  onCourseSave(): void {
    this.saveProgressChanges();
    this.editMode = false;
  }

  /**
   * Manually trigger certificate generation for this user
   * Uses actual enrollment data including certificate status
   */
  onGenerateCertificate(): void {
    if (this.isGeneratingCertificate || !this.user?.id || !this.userCourseDto) {
      this.alertify.warning('Please wait for user data to load before generating certificate.');
      return;
    }

    console.log('checking user dto: ', this.userCourseDto);

    // Check if certificate was already sent
    if (this.userCourseDto.isCertificateSent === 'true') {
      this.alertify.warning('Certificate has already been sent to this user.');
      return;
    }

    this.isGeneratingCertificate = true;

    // Use the actual enrollment data (with real certificate status)
    const userCourseDto: UserCourseDto = {
      ...this.userCourseDto,
      isCourseComplete: 'false' // Force to 'no' to trigger certificate generation check
    };

    // Call the enhanced API method that returns comprehensive completion status
    this.userClassesService.CheckAllClassesComplete(userCourseDto)
      .subscribe({
        next: (response: any) => {
          this.isGeneratingCertificate = false;
          
          if (response.isFullyComplete) {
            if (response.certificateGenerated) {
              this.alertify.success('Certificate generation completed successfully! Email sent to user.');
              // Update local enrollment data to reflect certificate was sent
              this.userCourseDto.isCertificateSent = 'true';
              this.updateAdminDisplayStats();
            } else {
              console.log('Certificate generation API response(response):', response);
              this.alertify.success(`Course fully completed (${response.fullyCompletedClasses}/10 classes). Certificate may have been sent previously.`);
            }
            // Refresh the user data to show updated completion status
            this.refreshPage();
          } else {
            console.log('Certificate generation API response(response):', response);
            this.alertify.warning(
              `User has completed ${response.fullyCompletedClasses}/10 classes (${response.totalActivitiesCompleted}/30 activities). ` +
              `Course completion: ${response.completionPercentage}%. Cannot generate certificate until course is complete.`
            );
          }
        },
        error: (error) => {
          this.isGeneratingCertificate = false;
          console.error('Error generating certificate:', error);
          this.alertify.error('An error occurred while generating the certificate. Please try again.');
        }
      });
  }

  refreshPage(): void {
    if (this.isRefreshing) return;
    
    this.isRefreshing = true;
    const currentId = this.id;
    const ppp = this.authService.getCD();
    
    // Reset edit modes
    this.editPersonalMode = false;
    this.editPasswordMode = false;
    this.editMode = false;
    
    // Reset form states
    this.updatePersonalFormState();
    this.updatePasswordFormState();
    
    // Refresh user data
    this.getUser(Number(currentId), ppp);
    this.GetAllClassesTakenByUser(Number(currentId));
    
    // Refresh enrollment data for the viewed user
    this.initializeEnrollmentData();
    
    // Stop refresh indicator after a short delay
    setTimeout(() => {
      this.isRefreshing = false;
    }, 1000);
  }

  

  constructor(private fb: FormBuilder, private router: Router,private route: ActivatedRoute,
    private userService: UserService, public authService: AuthService, private countryService: CountryService, private alertify: AlertifyService,private actRoute: ActivatedRoute,
    private userClassesService: UserClassesService, public classService: ClassService, private userEnrolmentService: UserEnrolmentService) { }

  ngOnInit() {
    // Initialize forms early to prevent template errors
    this.initializeForms();
    
    // let userId = this.authService.returnCurrentUser().id
    let ppp = this.authService.getCD();

    this.id = this.actRoute.snapshot.params['id'];
    // console.log("id: " + this.id);

    this.getUser(Number(this.id), ppp);
    
    // this.getCountryList();

    this.GetAllClassesTakenByUser(Number(this.id));
    // const d = new Date("2022-03-25");
    
    // Initialize enrollment data once on component load
    this.initializeEnrollmentData();
  }

  private initializeEnrollmentData(): void {
    // Get enrollment data for the user being viewed by admin (not the admin user)
    if (this.id) {
      this.userClassesService.GetUserEnrolment(Number(this.id), 1).subscribe({
        next: (enrollmentData) => {
          this.userCourseDto = enrollmentData;
          
          // Get initial course completion status for the viewed user
          this.userClassesService.CheckAllClassesComplete(enrollmentData).subscribe((courseCompleted: number) => {
            this.courseCompleted = courseCompleted;
            this.updateAdminDisplayStats();
          });
        },
        error: (error) => {
          console.warn('No enrollment data found for user, creating defaults:', error);
          // Create default enrollment data for users not yet enrolled
          this.userCourseDto = createUserCourseDto({
            userId: Number(this.id),
            courseId: 1,
            isCourseComplete: 'false',
            isCertificateSent: 'false'
          });
          
          this.userClassesService.CheckAllClassesComplete(this.userCourseDto).subscribe((courseCompleted: number) => {
            this.courseCompleted = courseCompleted;
            this.updateAdminDisplayStats();
          });
        }
      });
    }
  }

  /**
   * Update admin-specific display statistics
   */
  private updateAdminDisplayStats(): void {
    if (this.userCourseDto && this.courseCompleted !== undefined) {
      // Calculate completion percentage for admin display
      const completionPercentage = (this.courseCompleted * 100) / 30;
      
      // Store stats for template display
      this.adminStats = {
        enrollmentDate: this.userCourseDto.dateEnrolment,
        isCertificateSent: this.userCourseDto.isCertificateSent === 'true',
        courseCompleted: this.userCourseDto.isCourseComplete === 'true',
        completionDate: this.userCourseDto.whenCourseCompleted,
        completionPercentage: Math.round(completionPercentage),
        activitiesCompleted: this.courseCompleted,
        totalActivities: 30
      };
    }
  }

  private initializeForms() {
    // Initialize userPassForm with default values to prevent template errors
    this.userPassForm = this.fb.group({
      email1: ['', [Validators.required]],
      pass: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(12)]],
    });
    // Disable the initial form
    this.userPassForm.disable();
  }

  GetAllClassesTakenByUser(userId: number) {
    this.userClassesService.GetAllClassesTakenByUser(userId).subscribe((userClassesTakenList: UserClassesTaken[]) => {
      this.userClassesTakenList = userClassesTakenList;
      
      //get the number of classes that user has started
      let length = this.userClassesTakenList.length;

      //sanitize the isAvailable field for null values
      this.userClassesTakenList.forEach(uct => {
        this.userClassesListds.set(uct.classId, uct);
      });

      //check if the user has not started any classes or if they have started all 10
      if (length == null || length < 10) {

        let uid = this.authService.returnCurrentUser().id

        //increase to the first null class
        length++;
        
        //loop through all of the classesn and make sure the array is 10 elements long
        for (let i = 0 ; i < 10; i++) {
          let uct: UserClassesTaken;
          if (this.userClassesListds.has(i + 1)) {
            uct = this.userClassesListds.get(i + 1);
          } else {
            // initialize the first class after the last started one
            uct = {
              classId: i + 1,
              userId: Number(this.id), //this.authService.returnCurrentUser().id,
              videoLength: 0,
              videoWatched: 0,
              isQuizCompleted: false,
              isVideoCompleted: false,
              isHandoutCompleted : false,
              whenClassStarted: null,
              whenClassCompleted: null,
              isAvailable: false,
            };
          }

          this.userClassesTakenList[i] = uct;

        }
        
        // console.log(this.userClassesTakenList);
      }
      
      // console.log(this.userClassesTakenList);


    }, error => {
      this.alertify.error(error);
    }, () => { // third part , complete
      //do nothing
    }
    );
  }

  saveProgressChanges() {
    console.log("Save Progress");
    // console.log(this.userClassesTakenList);
    // console.log(this.isAvailable);
    this.userClassesService.UpdateAllUserClassesTaken(this.userClassesTakenList).subscribe(next => {
      console.log("Classes Updated")
    }, error => {
      this.alertify.error(error);
    }, () => {

    });
    
    this.editMode = false;
  }

  GetAllClasses() {
    this.classService.getAllClasses().subscribe((userClasses: classItem[]) => {
      this.userClassesList = userClasses;
      //this.userClassesListds.set("classes", this.userClassesList);

    }, error => {
      this.alertify.error(error);
    }, () => { // third part , complete
      //do nothing
    }
    );
  }

  getStartedDate(uct: UserClassesTaken) {
    if (uct.whenClassStarted != null) {
      let startingDate = new Date(uct.whenClassStarted);
      return startingDate.toDateString(); //.toDateString() .toLocaleString()
    } else {
      return "Not Started";
    }
  }

  getCompletedDate(uct: UserClassesTaken) {
    let defaultDate = new Date("0001-01-01T00:00:00");
    if (uct.whenClassCompleted != null && uct.whenClassCompleted != defaultDate) {
      let completedDate = new Date(uct.whenClassCompleted);
      return completedDate.toDateString(); //.toDateString() .toLocaleString()
    } else {
      return "Not Completed";
    }
  }

  getAvailableDate(uct: UserClassesTaken) {
    //Only process available date if not in the first class
    if(uct.classId != 1) {
      let defaultDate = new Date("0001-01-01T00:00:00");
      //find out if the previous class was completed
      let previousClass = this.userClassesTakenList[uct.classId - 2];
      // console.log("previous Class");
      // console.log(previousClass);
      if (previousClass.whenClassCompleted != null) {
        let previousDate = new Date(previousClass.whenClassCompleted)
        if (previousDate.getTime() != defaultDate.getTime()) {
          // console.log("AvailableDates");
          // console.log(defaultDate);
          // console.log(previousDate);
          let availableDate = new Date(previousClass.whenClassCompleted);
          // console.log("AvailableDates1");
          // console.log(availableDate);
          availableDate.setDate(availableDate.getDate() + 7); 
          // console.log(availableDate);
          return availableDate.toDateString();
          //return "now";
        } else {
            return "TBD"
          }
      } else {
        return "TBD"
      }
    //return the date if the class was started
    // } else if (uct.whenClassStarted != null) {
    //   let availableDate = new Date(uct.whenClassStarted);
    //   return availableDate.toDateString();
    //return string available if not started
    } else {
      return "Available"
    }
  }

  CreateUserProfForm(user: UserOne) {
    console.log('Creating form with user data:', {
      firstName: user?.firstName,
      lastName: user?.lastName,
      email: user?.email,
      countryId: user?.countryId,
      stateId: user?.state,
      city: user?.city,
      state: user?.state,
      address: user?.address,
      zipCode: user?.zipCode,
      phoneNumber: user?.phone
    });
    
    this.userProfForm = this.fb.group({
      id: [user?.id, Validators.required],
      userName: [user?.email, Validators.required],
      email: [user?.email, [Validators.required, Validators.pattern(this.emailPattern)]],
      firstName: [user?.firstName, [Validators.required]],
      lastName: [user?.lastName, [Validators.required]],
      countryId: [user?.countryId || '', Validators.required], // Will be set to actual user value or empty
      state: [user?.state || ''], // Will be set to actual user value or empty
      city: [user?.city, [Validators.required]],
      address: [user?.address || ''], // Optional field
      zipCode: [user?.zipCode || ''], // Optional field
      phoneNumber: [user?.phone || ''], // Optional field
    });
    
    // Log the actual form values after creation
    console.log('Form values after creation:', {
      countryId: this.userProfForm.get('countryId')?.value,
      state: this.userProfForm.get('state')?.value
    });
    
    // Disable all form controls by default
    this.userProfForm.disable();
  }

  CreateUserPassForm(user: UserOne) {
    this.userPassForm = this.fb.group({
      email1: [this.user?.email, [Validators.required]],
      pass: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(12)]],
    });
    
    // Disable all form controls by default
    this.userPassForm.disable();
  }

  saveUser() {
    let ppp = this.authService.getCD();
    
    if (this.userProfForm.valid) {
      // Create a complete UserOne object with existing data and form updates
      const userUpdateData: UserOne = {
        ...this.user, // Preserve all existing user data
        // Update only the fields from the form that exist in UserOne
        firstName: this.userProfForm.value.firstName,
        lastName: this.userProfForm.value.lastName,
        email: this.userProfForm.value.email,
        countryId: this.userProfForm.value.countryId,
        state: this.userProfForm.value.state || undefined,
        city: this.userProfForm.value.city,
        address: this.userProfForm.value.address || undefined,
        zipCode: this.userProfForm.value.zipCode || undefined,
        phone: this.userProfForm.value.phoneNumber || undefined
        // Password fields are preserved from this.user and not changed
      };

      console.log('Updating user info:', userUpdateData);

      this.userService.updateUserInfo(userUpdateData, ppp).subscribe(() => {
        this.alertify.success('Update successful');
        // Update the local user object with the new values
        this.user = userUpdateData;
      }, error => {
        console.log(error);
        this.alertify.error(error);
      });
    } else {
      this.alertify.error('Please fix form errors before saving');
    }
  }

  savePass() {
    let ppp = this.authService.getCD();
    console.log("Password form valid:", this.userPassForm.valid);
    
    if (this.userPassForm.valid) {
      // Create a minimal object with only the data needed for password change
      // Note: this.user.password is always null from backend (security measure)
      const passwordChangeData = {
        userId: this.user.id,  // Changed from 'id' to 'userId' to match backend expectation
        email: this.user.email,
        password: this.userPassForm.value.pass  // Only the new password from form
      };
      
      console.log("Changing password for user:", passwordChangeData.email);
      console.log("Current user.password from backend (should be null):", this.user.password);
      console.log("ID for password change:", passwordChangeData.userId);

      this.userService.changePass(passwordChangeData as UserOne, ppp).subscribe(() => {
        this.alertify.success('Password Change Successful');
        // Clear the password form after successful change
        this.userPassForm.get('pass')?.setValue('');
        // Note: this.user.password remains null as it should (backend security)
      }, error => {
        console.log("Password change error:", error);
        console.log("Submitted password:", passwordChangeData);
        this.alertify.error(error);
      }, () => { 
        // Optional: Reset edit mode after completion
        // this.editPasswordMode = false;
        // this.updatePasswordFormState();
      });
    } else {
      this.alertify.error('Please fix form errors before saving password');
    }
  }


  getUser(id: number, ppp: string) {
    this.userService.getUserById(id, ppp).subscribe((useridValue: UserOne) => {
      this.user = useridValue; // class 1, 2..
      console.log('Fetched user data:');
      console.log('User: ', this.user);
      this.CreateUserProfForm(useridValue);
      this.CreateUserPassForm(useridValue);
      
      // Ensure forms are in correct disabled state
      this.updatePersonalFormState();
      this.updatePasswordFormState();
      
      this.getCountryList();
      this.getStatesList();
      //console.log(this.class);
    }, error => {
      this.alertify.error(error);
    }, () => { // third part , complete
      //set default country
      //get Url from dataBase
    }
    );
  }


  addToClass() {
    this.model = Object.assign({}, this.addToClassForm.value);
  
    this.authService.addToClass(this.model).subscribe(next => {
      this.alertify.success('Users have been added to the class.');
      // tslint:disable-next-line:no-shadowed-variable
    }, error => {
      this.alertify.error(error); //  'Failed to loginsss');
    }, () => {
        this.router.navigate(['/login']);
    }
    );
  }

  register() {
    this.router.navigate(['/register']);
  }

  getCountryList() {
    console.log('getCountryList'); 
    this.countryService.getCountriesList().subscribe((countries: Country[]) => {
      this.countries = countries;
      console.log('Countries loaded:', countries);
      
    }, error => {
      this.alertify.error(error);
    }, () => { 
      // Only set default country if user doesn't have one already
      if (this.userProfForm && (!this.user?.countryId || this.user.countryId === '')) {
        this.userProfForm.controls['countryId'].setValue('US');
      }
    });
  }

  getStatesList() {
    console.log('getStatesList');
    this.countryService.getStatesList().subscribe((states: State[]) => {
      this.states = states;
      console.log('States loaded:', states);
    }, error => {
      console.log('Error loading states:', error);
      // Don't show error to user since states are optional
    });
  }

  // Navigation methods for the new panel layout
  setActivePanel(panel: string) {
    this.activePanel = panel;
  }

  isActivePanelClass(panel: string): string {
    return this.activePanel === panel ? 'active' : '';
  }

  // Method to check if selected country is US
  isUSSelected(): boolean {
    if (!this.userProfForm) return false;
    return this.userProfForm.get('countryId')?.value === 'US';
  }

  getUserInitials(): string {
    if (!this.user || !this.user.firstName || !this.user.lastName) {
      return 'U';
    }
    return this.user.firstName.charAt(0).toUpperCase() + this.user.lastName.charAt(0).toUpperCase();
  }

  getUserFullName(): string {
    if (!this.user) {
      return 'Loading...';
    }
    return `${this.user.firstName || ''} ${this.user.lastName || ''}`.trim() || 'Unknown User';
  }

}
